import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import axios from "axios";
import { environment } from 'src/environments/environment';
import { TokenUtil } from '../core/services/TokenUtil.service';
import { ConnectionService } from '../modules/organization/connection.service';
import { AuthServiceService } from '../shared/services/auth-service.service';
import uniqid from 'uniqid';
import { BoxCache } from '../core/boxInstances/BoxCache';
import { BehaviorSubject } from 'rxjs';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FormService } from '../form/form.service';
import { FlowService } from './flow.service';
import { PageService } from '../bloom/services/page-service.service';
import { AutomationService } from '../bloom/services/automation.service';

@Injectable({
  providedIn: 'root'
})
export class FlowTriggerService {
  constructor(
    public connectionService: ConnectionService,
    private formService: FormService,
    public flowService: FlowService,
    private pageService: PageService,
    private automationService: AutomationService,
  ) { }

    /**
   * Fetches flow data by ID and processes it if it's a form-type trigger
   *
   * @param id - The ID of the flow to retrieve or a flow object with a code attribute
   */
    async getFlowAndFormStructure(id){
      // Variable to hold the flow data
      let flow;
      
      // Check if id is an object with a code property (direct flow object)
      if (typeof id === 'object' && id !== null && id.code) {
        flow = id;
      } else {
        // Assume id is a string ID and fetch the flow data from the service
        flow = await this.flowService.getFlow(id);
      }
      
      console.log("flow to generate", flow);
      // Check if the flow has a form trigger type
      if(flow.trigger_type == 'form'){
        // Transform flow payload data into form attributes
        let formAttributes = [];
        for (const key in flow.trigger.payload_data) {
          // Extract each attribute from the payload data
          const attribute = flow.trigger.payload_data[key];
          // Set default properties for form rendering
          attribute.enabled = true;
          attribute.widgetType = "input"; // Default widget type for form fields
          formAttributes.push(attribute);
        }
        // Generate the form structure using the extracted attributes
        return await this.generateFormMeta(formAttributes, flow.trigger);
      }
    }
  
    /**
     * Generates the form metadata structure from the provided form attributes
     *
     * @param formAttributes - Array of form field attributes extracted from flow payload
     */
    async generateFormMeta(formAttributes, trigger){
      // Create the main form panel to hold form fields
      let formPanel = this.formService.createFormPanel({}, "get")
  
      // Create and configure the submit button
      let submitButton:any = this.formService.formPanelButton({}, "get");
      submitButton.id = Date.now(); // Generate unique ID for the button
  
      
  
      // Configure the button's action to use flow_webhook for form submission
      submitButton['actionConfig']['actions'][0]['actionMap']['mapping'] = [];
      submitButton['actionConfig']['actions'][0]['actionMap']['webhook_url'] = trigger.webhook_url;
  
  
      // Attach the submit button to the form panel
      formPanel.submitButtonMeta = submitButton;
      formPanel.name = 'formPanel_1';
      // Generate a unique ID for the form panel with a time offset
      formPanel.id = new Date().setSeconds(new Date().getSeconds() + 50).valueOf();
      // Attach the form attributes to the panel
      formPanel.formAttributes = formAttributes;
  
      // Generate the actual form widgets based on the attributes
      // This transforms the abstract attributes into concrete UI components
      formPanel = this.automationService.generateFormWidgets(
        formAttributes,
        formPanel,
        submitButton,
        submitButton['actionConfig']['actions'][0]['actionMap'].action
      )
  
      // Add navigation action to the submit button (for redirecting after submission)
      submitButton['actionConfig']['actions'].push(this.formService.createNavAction());
      // Enable form validation on submit
      submitButton['checkValidation'] = true;
  
      // Create a separate panel for the submit button
      // This allows the submit button to be positioned independently of the form fields
      let tempPageMeta = await this.pageService.createPanel('button', {panels: []}, null)
      let submitPanel = tempPageMeta.panels[0]
      let colId = submitPanel.layoutMap.list[0]
      let rowId = submitPanel.layoutMap[colId].list[0]
  
      //get box config token for http box with webhookurl as config
      let boxConfigToken = await this.connectionService.getBoxConfigTokenFromBox("http", {url: trigger.webhook_url});
      //set actionmap as http box and post method
      submitButton['actionConfig']['actions'][0]['actionMap']['boxId'] = "http"
      submitButton['actionConfig']['actions'][0]['actionMap']['action'] = "post";
      submitButton['actionConfig']['actions'][0]['actionMap']['baseMap'] = null;
      submitButton['actionConfig']['actions'][0]['actionMap']['boxConfigToken'] = boxConfigToken;
      submitButton['actionConfig']['actions'][0]['actionMap']['origin'] = "flow_trigger";
  
      submitPanel.layoutMap[colId][rowId]['elements'][0] = submitButton;
  
      // Create the complete form by combining the form panel and submit panel
      var form: any = this.formService.createFormMeta({code: "temp", name: "temp"})
      form['panels'] = [ formPanel, submitPanel]
  
      // Log the generated form structure for debugging
      console.log("created form", form);
  
      // Publish the form metadata to the form service for rendering
      this.formService.formMeta.next(form);
      // Disable builder mode since we're displaying the form, not editing it
      this.formService.builderMode = false;
      this.formService.isPreview = true;
      return form;
      
    }

}
